export const LOAD_DATA_FAILURE = 'LOAD_DATA_FAILURE';
export const loadDataFailure = () => ({
    type: LOAD_DATA_FAILURE,
});

export const LOAD_DATA_SUCCESS = 'LOAD_DATA_SUCCESS ';
export const loadDataSuccess = data => ({
    type: LOAD_DATA_SUCCESS,
    payload: { data }
})

export const LOAD_DATA_IN_PROGRESS = 'LOAD_DATA_IN_PROGRESS';
export const loadDataInProgress = () => ({
    type: LOAD_DATA_IN_PROGRESS,
});

export const ERROR_MESSAGE = 'ERROR_MESSAGE';
export const errorMessage = () => ({
    type: ERROR_MESSAGE,
});

